import { render, staticRenderFns } from "./oc-slider.vue?vue&type=template&id=1e5c169c&scoped=true"
import script from "./oc-slider.vue?vue&type=script&lang=js"
export * from "./oc-slider.vue?vue&type=script&lang=js"
import style0 from "./oc-slider.vue?vue&type=style&index=0&id=1e5c169c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5c169c",
  null
  
)

export default component.exports